<template>
	<section id="status">
		<container>
			<load-content v-if="loadContent" />
			<div class="table-wrapper" v-if="colecoes.length > 0">
				<div class="table">
					<table>
						<thead>
							<tr>
								<th>Ordem de serviço</th>
								<th>Status</th>
								<th>Coleção</th>
								<th>Criado Por</th>
							</tr>
						</thead>

						<tbody>
							<tr class="fields" v-for="(colecao, index) in colecoes" :key="index">
								<td><span class="numero">{{ colecao.numero }}</span></td>
								<td><span>{{ colecao.status }}</span></td>
								<td><span>{{ colecao.nome }}</span></td>
								<td><span>{{ colecao.autor }}</span></td>
							</tr>
						</tbody>
					</table>
				</div>
					<div class="paginacao" v-if="totalItens > 20">
						<Pagination :totalItens="totalItens" :currentPage="paginaAtual" @pagina="getPaginaAtual" />
					</div>
			</div>
			<div class="not-found" v-else-if="inicial">
					Não existe nenhum status :)
			</div>
		</container>
	</section>
</template>

<script>
import container from '@/components/shared/Container'

import Pagination from '@/components/shared/Pagination'
import LoadContent from '@/components/shared/LoadContent'
import { colecoes } from '@/services/colecoes'
export default {
	components: { container, Pagination, LoadContent },
	data () {
		return {
			params: {
				nome: '',
				status: 'Enviado,Pendente,Finalizado,Cancelado'

			},
			colecoes: [],
			paginaAtual: 1,
			inicial: false,
			loadContent: true,
			totalItens: 20
		}
	},
	async created () {
		this.getPaginaAtual()
	},
	methods: {
		async getPaginaAtual () {
			// this.loadContent = true
			this.params = {
				...this.params,
				...this.$route.query
			}

			if (this.params && this.params.skip) {
				this.paginaAtual = parseInt(this.params.skip)
				this.params.skip = parseInt(this.params.skip) - 1
			} else {
				this.paginaAtual = 1
				this.params.skip = 0
			}

			this.colecoes = []

			await colecoes.find(this.params)
				.then(res => {
					this.colecoes = res.data
					this.totalItens = res.data[0].total
				})
				.catch(err => console.log(err))
			this.inicial = true
			this.loadContent = false
		}
	}
}
</script>

<style lang="scss" scoped>
#status {
	.table-wrapper {
		.table {
			td {
				vertical-align: middle;
				font-size: .9em;
			}

			.numero {
				background-color: #C7D2DF;
				padding: 7px;
				border-radius: 14px;
			}
			.fields:nth-child(2n+1) {
				.numero {
					background-color: #F3F7FC;
				}
			}
		}
	}

	.not-found {
		margin-top: 50px;
		color: #000;
		text-align: center;
	}
}
</style>
